<template>
  <div>
    <!-- Sign type selection -->
    <v-select :value="hardwareKey"
              @input="$emit('input', $event)"
              color="primary"
              :label="$t('eds.keyCarrier')"
              :placeholder="$t('eds.selectKeyCarrier')"
              :items="keyMedias"
              item-text="visibleName"
              return-object
              hide-details
              menu-props="offsetY"
              outlined dense
              :disabled="loading"
              class="body-1 mb-8">

      <template #prepend-inner>
        <v-icon small class="pt-1 pr-2">md mdi-usb-flash-drive</v-icon>
      </template>

      <template #append-item>
        <a v-if="!keyMedias.length"
          class="ml-4 primary--text body-2 text-decoration-underline"
          @click="$emit('reload')"
          v-text="$t('eds.refresh')"/>
      </template>

    </v-select>

    <!-- Key password input -->
    <v-text-field :value="password"
                  @input="$emit('update:password', $event)"
                  :label="$t('login.password')"
                  :placeholder="$t('eds.passwordPlaceholder')"
                  outlined dense
                  name="password"
                  type="password"
                  hide-details
                  clearable
                  :disabled="loading || !hardwareKey"
                  autocomplete="off"
                  @keyup.enter="$emit('sign')"
                  class="body-1 clearable mb-8">

      <template #prepend-inner>
        <v-icon small class="pt-1 pr-2">md mdi-lock-open</v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'EdsHardwareKey',
  model: {
    prop: 'hardwareKey'
  },
  props: {
    keyMedias: {
      type: Array
    },
    hardwareKey: {
      type: Object
    },
    password: {
      type: [String, null]
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
